import {DeepNonNullable} from "./statics";


export class AssertionError extends Error {
  readonly value: unknown;
  constructor(message: string, value: unknown) {
    super(message);
    this.name = 'AssertionError';
    this.value = value;
  }
}

export function assertExists<T>(value: T|undefined|null): asserts value is T {
  if (value === undefined || value === null) {
    throw new AssertionError('Value is not set', value);
  }
}

export function assertExistsDeep<T>(value: T|undefined|null): asserts value is T & DeepNonNullable<T> {
  if (value === undefined || value === null) {
    throw new AssertionError('Value is not set', value);
  }
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return;
    }
    for (const key in value) {
      assertExistsDeep(value[key]);
    }
  }
}
export function assertUnreachable(value: never): never {
  throw new AssertionError('Unreachable code reached', value);
}
export function assertTruthy<T>(value: T): asserts value is Exclude<T, false|0|''|null|undefined> {
  if (!value) {
    throw new AssertionError('Expected truthy value', value);
  }
}

export function assertString(value: unknown): asserts value is string {
  if (typeof value !== 'string') {
    throw new AssertionError('Expected string', value);
  }
}

export function assertNumber(value: unknown): asserts value is number {
  if (typeof value !== 'number') {
    throw new AssertionError('Expected number', value);
  }
}

export function assertLength<T>(value: T[], length?: number): asserts value is T[];
export function assertLength<T>(value: readonly T[], length?: number): asserts value is readonly T[] {
  if (length === undefined && !value.length) {
    throw new AssertionError(`Expected non-empty array, got empty array`, value);
  }
  if (length !== undefined && value.length !== length) {
    throw new AssertionError(`Expected length ${length}, got ${value.length}`, value);
  }
}
